module.exports = "<router-outlet></router-outlet>\r\n<div class=\"sidenav-overlay d-none\" id=\"sidenav-overlay\" (click)=\"rightbar($event)\"></div>\r\n"